import { render } from "./AccountDeletion.vue?vue&type=template&id=bc819f60&scoped=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=js"
export * from "./AccountDeletion.vue?vue&type=script&lang=js"

import "./AccountDeletion.vue?vue&type=style&index=0&id=bc819f60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc819f60"]])

export default __exports__